import {
  GET_AS2_RESPONSE_HISTORY,
  GET_AS2_RESPONSE_STATS,
  GET_RECENT_AS2_RESPONSES,
  RETRY_AS2_TRANSMISSION,
  UPDATE_AS2_RESPONSE_STATUS
} from '../types'

const INITIAL_STATE = {
  responseHistory: [],
  responseStats: {},
  recentResponses: [],
  retryStatus: null,
  loading: false,
  error: null
}

const as2ResponseReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_AS2_RESPONSE_HISTORY:
      return {
        ...state,
        responseHistory: payload?.data || [],
        loading: false,
        error: null
      }

    case GET_AS2_RESPONSE_STATS:
      return {
        ...state,
        responseStats: payload?.data || {},
        loading: false,
        error: null
      }

    case GET_RECENT_AS2_RESPONSES:
      return {
        ...state,
        recentResponses: payload?.data || [],
        loading: false,
        error: null
      }

    case RETRY_AS2_TRANSMISSION:
      return {
        ...state,
        retryStatus: payload?.data || null,
        loading: false,
        error: null
      }

    case UPDATE_AS2_RESPONSE_STATUS:
      const { responseId, status } = payload
      return {
        ...state,
        responseHistory: state.responseHistory.map(response => 
          response.id === responseId 
            ? { ...response, status, processedAt: new Date().toISOString() }
            : response
        ),
        recentResponses: state.recentResponses.map(response => 
          response.id === responseId 
            ? { ...response, status, processedAt: new Date().toISOString() }
            : response
        )
      }

    default:
      return state
  }
}

export default as2ResponseReducer 